import React from "react";

import styled from "@emotion/styled";

import { isWebView } from "../../../../../utils/webViewRedirect";
import Headline from "../../../../shared/Headline";
import LinkComponent from "../../../../shared/LinkComponent";
import LoadingIndicator from "../../../../shared/LoadingIndicator";
import TextAlign from "../../../../shared/TextAlign";
import useStepOverviewStore from "../StepOverview/store";
import * as styles from "./style.module.scss";

const LinkContainer = styled.div`
    margin-top: 2em;
`;

const StepSuccess = () => {
    const [loading, order, contact] = useStepOverviewStore((state) => [
        state.loading,
        state.order,
        state.contact,
    ]);

    return (
        <section>
            {loading ? (
                <React.Fragment>
                    <Headline center>Ihre Bestellung wird übermittelt</Headline>
                    <TextAlign Component="p" align="center">
                        Haben Sie einen Moment Geduld
                    </TextAlign>
                    <LoadingIndicator />
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Headline>Vielen Dank für Ihre Bestellung</Headline>
                    {order !== null && (
                        <p>
                            Ihr Auftrag ist bei uns eingegangen und wird in
                            Kürze bearbeitet. Ihre Auftragsnummer lautet{" "}
                            <strong>{order.order_number}</strong>.
                        </p>
                    )}
                    {contact !== null && (
                        <>
                            <p>
                                Sie erhalten eine Bestellbestätigung per E-Mail.
                            </p>
                            <div className={styles.contact}>
                                <div className={styles.contactInfo}>
                                    <strong>Ihr Team von</strong>
                                    <br />
                                    {contact.team_name}
                                    <br />
                                    {contact.street}
                                    <br />
                                    {contact.zipcode} {contact.city}
                                    <br />
                                    Tel.: {contact.phone}
                                    <br />
                                    E-Mail:{" "}
                                    <a href={`mailto:${contact.email}`}>
                                        {contact.email}
                                    </a>
                                </div>
                            </div>
                        </>
                    )}
                    {/* Show a redirect back to calculator on webview since there is no other navigation */}
                    {isWebView() && (
                        <LinkContainer>
                            <LinkComponent
                                link={{
                                    href: "/webview/heizoel",
                                    text: "Zurück zum Heizölrechner",
                                }}
                                color="red"
                            />
                        </LinkContainer>
                    )}
                </React.Fragment>
            )}
        </section>
    );
};

export default StepSuccess;
